module.exports = __webpack_public_path__ + "static/media/chevron-down.ffc15f3b.svg";